var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3AoLcomIdv8SM3GaO1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "logo",
    height: 36,
    viewBox: "0 78 256 101",
    width: 101,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 138.551 100.738 C 164.939 100.738 177.613 121.602 177.613 139.453 C 177.613 157.305 164.939 178.175 138.55 178.175 C 112.15 178.175 99.481 157.305 99.481 139.453 C 99.481 121.603 112.15 100.738 138.547 100.738 M 138.547 157.834 C 147.947 157.834 155.919 150.084 155.919 139.453 C 155.919 128.82 147.947 121.081 138.545 121.081 C 129.139 121.081 121.161 128.82 121.161 139.453 C 121.161 150.084 129.139 157.834 138.545 157.834 M 189.874 79 H 211.857 V 176.14 H 189.874 Z M 238.119 147.61 C 230.056 147.61 223.524 154.16 223.524 162.213 C 223.524 170.275 230.059 176.817 238.119 176.817 C 246.185 176.817 252.734 170.273 252.734 162.213 C 252.734 154.159 246.185 147.61 238.119 147.61 M 59.833 79 H 40.261 L 2 176.137 H 27.927 L 33.056 162.099 H 66.791 L 71.514 176.137 H 97.707 L 59.833 79 Z M 39.881 142.395 L 50.057 108.527 L 60.228 142.399 H 39.88 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3AoLcomIdv8SM3GaO1);
export default __webpack_public_path__ + "static/media/3_AOL.com_idv8sM3GaO_1.fbda5fe399149da4ec63a1eb851aebf8.svg";
export { ForwardRef as ReactComponent };